module.exports = __webpack_public_path__ + "img/laprecision-logo-p-placeholder.da4a5215.png";